// NOTE: 非活性ということを視覚的にわかりやすくする設定
// NOTE: inputSxは現状使用していない
// TODO createThemeを使ってテーマを作成したほうがいいかもしれないが現状共通のルールがないので保留
const disabledSx = {
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "#f0f0f0",
    color: "#999",
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "#aaa",
  },
};

const inputSx = {
  ...disabledSx,
};

/**
 * 改行スタイル
 */
const multilineSx = {
  whiteSpace: "normal",
  overflowWrap: "break-word",
  wordBreak: "break-word",
};

export { inputSx, multilineSx };
